
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/john-deere",
      function () {
        return require("private-next-pages/customers/john-deere.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers/john-deere"])
      });
    }
  